import {
    SET_WARRANTY_SETTINGS_DATA_LOADING,
    SET_WARRANTY_SETTINGS_DATA,
    SET_WARRANTY_PERIODS_DATA,
    CLEAR_WARRANTY_SETTINGS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    warrantySettingsData: [],
    warrantyPeriodsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_WARRANTY_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_WARRANTY_SETTINGS_DATA:
            return {
                ...state,
                warrantySettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        case SET_WARRANTY_PERIODS_DATA:
            return {
                ...state,
                warrantyPeriodsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        case CLEAR_WARRANTY_SETTINGS_DATA:
            return {
                ...state,
                warrantySettingsData: [],
                warrantyPeriodsData: [],
                isLoading: false,
            };
        default:
            return state;
    }
}

